import { TitleDivider } from '@stack/ui/components';
import useTranslation from 'next-translate/useTranslation';

import CarVideosGallery from './CarVideosGallery';
import { CarVideosProps } from './props';
import { Stack, Typography } from '@mui/material';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarVideos: React.FC<CarVideosProps> = (props) => {
  const { newCarVideos, showTitle = true } = props;

  // ===================== EVENTS

  // Check whether newCarVideos is not null and has videos
  const hasVideos = Object.values(newCarVideos || {}).some(
    (videos) => Array.isArray(videos) && videos.length > 0
  );

  // ===================== HOOKS
  const { t } = useTranslation('common');

  // ===================== RENDER FUNCTIONS
  const renderVideoContent = () => {
    if (!hasVideos)
      return (
        <Stack
          position={'relative'}
          justifyContent={'center'}
          border={'1px solid #EDECED'}
          sx={{ marginTop: 5, minHeight: 156 }}
        >
          <Typography textAlign={'center'} fontSize={16} fontWeight={400}>
            No Video Found
          </Typography>
        </Stack>
      );
    return <CarVideosGallery newCarVideosList={newCarVideos} />;
  };
  return (
    <TitleDivider title={showTitle ? t('carDetail.videos') : ''}>
      {renderVideoContent()}
    </TitleDivider>
  );
};

export default CarVideos;
